import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';

export default function Login() {
  const { login, user } = useAuth();
  const { brand }       = useBrand();
  const navigate        = useNavigate();

  const primary  = brand.primary_color || '#0099FF';
  const dark     = brand.dark_color    || '#151515';
  // Use login-specific logo if set, otherwise fall back to sidebar logo
  const logoUrl  = brand.login_logo_url || brand.logo_url || '';

  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  if (user) return <Navigate to="/" replace />;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) return setError('Email and password are required');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  const inp = {
    width:'100%', padding:'9px 12px', borderRadius:8,
    border:'1px solid #d1d5db', fontSize:13, outline:'none', boxSizing:'border-box',
  };

  return (
    <div style={{ minHeight:'100vh', background:dark, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Inter',system-ui,sans-serif" }}>
      <div style={{ width:420, background:'#fff', borderRadius:20, padding:40, boxSizing:'border-box', boxShadow:'0 25px 50px rgba(0,0,0,0.4)' }}>

        {/* Logo / Branding */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={brand.app_name || 'Logo'}
              style={{ maxHeight:60, maxWidth:'80%', objectFit:'contain', display:'block', margin:'0 auto 14px' }}
            />
          ) : (
            <div style={{ width:52, height:52, borderRadius:14, background:primary, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
              <i className="ti ti-bolt" style={{ fontSize:26, color:'#fff' }} />
            </div>
          )}
          
            </div>

        <form onSubmit={handleLogin}>
          {/* Email */}
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:12, fontWeight:500, color:'#374151', marginBottom:6, display:'block' }}>Email Address</label>
            <div style={{ position:'relative' }}>
              <i className="ti ti-mail" style={{ position:'absolute', left:11, top:'50%', transform:'translateY(-50%)', color:'#9ca3af', fontSize:16 }} />
              <input type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)}
                style={{ ...inp, paddingLeft:34 }} />
            </div>
          </div>

          {/* Password */}
          <div style={{ marginBottom:8 }}>
            <label style={{ fontSize:12, fontWeight:500, color:'#374151', marginBottom:6, display:'block' }}>Password</label>
            <div style={{ position:'relative' }}>
              <i className="ti ti-lock" style={{ position:'absolute', left:11, top:'50%', transform:'translateY(-50%)', color:'#9ca3af', fontSize:16 }} />
              <input type={showPass?'text':'password'} placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)}
                style={{ ...inp, paddingLeft:34, paddingRight:38 }} />
              <button type="button" onClick={() => setShowPass(!showPass)}
                style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'#9ca3af', padding:0 }}>
                <i className={`ti ${showPass?'ti-eye-off':'ti-eye'}`} style={{ fontSize:16 }} />
              </button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={{ color:'#EF4444', fontSize:12, marginBottom:12, background:'#fef2f2', borderRadius:8, padding:'8px 12px', display:'flex', alignItems:'center', gap:6 }}>
              <i className="ti ti-alert-circle" style={{ fontSize:14 }} />{error}
            </div>
          )}

          {/* Submit */}
          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:'11px 16px', borderRadius:8, border:'none', background:primary, color:'#fff', fontSize:14, fontWeight:600, cursor:loading?'not-allowed':'pointer', marginTop:8, marginBottom:20, display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:loading?0.85:1, transition:'opacity 0.15s' }}>
            {loading ? (
              <>
                <div style={{ width:16, height:16, border:'2px solid rgba(255,255,255,0.4)', borderTop:'2px solid #fff', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
                Signing in...
              </>
            ) : <>Sign In <i className="ti ti-arrow-right" style={{ fontSize:15 }} /></>}
          </button>
        </form>

        {/* OAuth divider */}
        <div style={{ position:'relative', textAlign:'center', marginBottom:20 }}>
          <div style={{ borderTop:'1px solid #e5e7eb', position:'absolute', top:'50%', width:'100%' }} />
          <span style={{ background:'#fff', padding:'0 12px', color:'#9ca3af', fontSize:12, position:'relative' }}>or continue with</span>
        </div>

        {/* OAuth buttons */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:24 }}>
          {[
            { label:'Hostinger', icon:'ti-server',        color:'#FF6C2F' },
            { label:'Gmail',     icon:'ti-brand-google',  color:'#EA4335' },
            { label:'Outlook',   icon:'ti-brand-windows', color:'#0078D4' },
          ].map(p => (
            <button key={p.label} type="button" onClick={() => setError(`${p.label} OAuth coming in Phase 2`)}
              style={{ padding:'9px 8px', borderRadius:8, border:'1px solid #e5e7eb', background:'#fff', cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:5 }}>
              <i className={`ti ${p.icon}`} style={{ fontSize:20, color:p.color }} />
              <span style={{ fontSize:11, color:'#374151', fontWeight:500 }}>{p.label}</span>
            </button>
          ))}
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
